import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/oracleManagement',
        name: 'oracleManagement',
        component: resolve => require(['@/views/oracleManagement/index'], resolve),
        meta: {
          title: '预言机管理',
          breadLevel: 0,
          icon: 'icon-oracle',
          auth: auth.oracle
        }
      }
    ]
  }
]

export default routes
